import { gql } from "urql";
export const blogFields = gql`
  fragment BlogFields on Blog {
    title
    slug
    excerpt
    minutesToRead
    featured
    content
    seo {
      metaTitle
      metaDescription
    }
    coverImage {
      data {
        attributes {
          url
          alternativeText
          name
        }
      }
    }
    blog_tags {
      data {
        attributes {
          name
        }
      }
    }
    blog_categories {
      data {
        attributes {
          name
        }
      }
    }
  }
`;
export const QUERY_ALL_BLOGS = gql`
  ${blogFields}
  query getBlogbyCategory(
    $limit: Int!
    $start: Int!
    $filter: BlogFiltersInput
    $sortBy: [String]
  ) {
    blogs(
      pagination: { start: $start, limit: $limit }
      filters: $filter
      sort: $sortBy
    ) {
      data {
        id
        attributes {
          ...BlogFields
        }
      }
      meta {
        pagination {
          total
        }
      }
    }
  }
`;

export const QUERY_BLOG_CATEGORIES = gql`
  query blogsByCategories {
    blogCategories(pagination: { limit: 50 }) {
      data {
        attributes {
          name
          blogs(pagination: { limit: 500 }) {
            data {
              id
            }
          }
        }
      }
    }
  }
`;

export const QUERY_ALL_BLOGS_TOTAL = gql`
  query getBlogsTotal {
    blogs {
      meta {
        pagination {
          total
        }
      }
    }
  }
`;

export const QUERY_ALL_BLOGS_SELECTIVE = gql`
  query getBlogbyCategory(
    $limit: Int!
    $start: Int!
    $filter: BlogFiltersInput
    $sortBy: [String]
  ) {
    blogs(
      pagination: { start: $start, limit: $limit }
      filters: $filter
      sort: $sortBy
    ) {
      data {
        id
        attributes {
          title
          slug
          excerpt
          blog_categories {
            data {
              attributes {
                name
              }
            }
          }
          coverImage {
            data {
              attributes {
                url
                alternativeText
                name
                formats
              }
            }
          }
        }
      }
      meta {
        pagination {
          total
        }
      }
    }
  }
`;
export const QUERY_BLOG_BY_SLUG = gql`
  ${blogFields}
  query blogBySlug($slug: String!) {
    blog(slug: $slug) {
      data {
        attributes {
          ...BlogFields
        }
      }
    }
  }
`;
